
import * as types from 'actions/action-types';
import { mockNotifications } from 'components/notifications_panel/mock_data';

var initialState = {
    notifications: [], // mockNotifications ?? [],
    notifications_pending: false,
    notifications_save_pending: false,
    notifications_unsubscribe: false,
    
    notification_messages: [], // mocknotification_messages ?? [],
    notification_messages_pending: false,
    notification_messages_save_pending: false,
    notification_messages_unsubscribe: false,
};

const NotificationsReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.NOTIFICATIONS + '_PENDING': pending('notifications'); break;
        case types.NOTIFICATIONS + '_SAVE_PENDING': save_pending('notifications'); break;
        case types.NOTIFICATIONS + '_SAVE_FULFILLED': save_fulfilled('notifications'); break;
        case types.NOTIFICATIONS + '_FULFILLED': fulfilled('notifications'); break;
        case types.NOTIFICATIONS + '_CLEAR': clear('notifications', {}); break;

        case types.NOTIFICATION_MESSAGES + '_PENDING': pending('notification_messages'); break;
        case types.NOTIFICATION_MESSAGES + '_SAVE_PENDING': save_pending('notification_messages'); break;
        case types.NOTIFICATION_MESSAGES + '_SAVE_FULFILLED': save_fulfilled('notification_messages'); break;
        case types.NOTIFICATION_MESSAGES + '_FULFILLED': fulfilled('notification_messages'); break;
        case types.NOTIFICATION_MESSAGES + '_CLEAR': clear('notification_messages', {}); break;

        default: break;
    }

    return state;

    function pending(table) {
        state = { ...state,
            [table + '_pending']: true,
        };
    }
    function save_pending(table) {
        state = { ...state,
            [table + '_save_pending']: true,
        };
    }
    function save_fulfilled(table) {
        state = { ...state,
            [table + '_saved']: action.data,
            [table + '_save_pending']: false,
        };
    }
    function fulfilled(table) {
        state = { ...state,
            [table]: action.data,
            [table + '_pending']: false,
            ...(action.unsubscribe) ? { [table + '_unsubscribe']: (action.unsubscribe) } : {},
        };
    }
    function clear(table, value) {
        state = { ...state,
            [table]: value,
        };
    }
};
export default NotificationsReducer;


